import React from 'react';
import { Alert } from '@im/ui-lib/zenith/Alert';

type PropsType = {
  message: string;
  onClose?: () => void;
};

const AddToQuoteAlert = ({ message, onClose }: PropsType) => {
  return (
    <div
      style={{
        left: '50%',
        position: 'absolute',
        top: '5%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
      }}
    >
      <Alert
        body={message}
        color="warning"
        hidePrimaryButton
        hideSecondaryButton
        onClose={onClose}
        size="floating"
      />
    </div>
  );
};

export default AddToQuoteAlert;
